import { render, staticRenderFns } from "./AuctionAddToWatchlist.vue?vue&type=template&id=b68af34c&scoped=true"
import script from "./AuctionAddToWatchlist.vue?vue&type=script&lang=js"
export * from "./AuctionAddToWatchlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68af34c",
  null
  
)

export default component.exports